import React from 'react';
import { STORE_TYPE } from '../../../common/types/types';
import { AnnotationHeader, ShowHideButton, useShowHideHandler } from '../annotation-header';
import type { HeaderInfoT } from '../annotations/types';
type PropsT = {
  label: string;
  headerInfo: HeaderInfoT;
  icon: React.ReactNode;
};
export function AnnotationDetailHeader({
  label,
  headerInfo,
  icon
}: PropsT) {
  const {
    handleShowHideAnnotation
  } = useShowHideHandler({
    storeType: STORE_TYPE.ML_ANNOTATION_STORE,
    label,
    headerInfo
  });
  return <AnnotationHeader headerInfo={headerInfo} label={label} icon={icon} showHideButton={(_, headerInfo) => <ShowHideButton headerInfo={headerInfo} onClick={handleShowHideAnnotation} />} />;
}